import { BaseInputFilter } from "domain/models/base-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { IJobTitleRepository } from "domain/contracts/job-title.contract";
import { JobTitle } from "domain/entities/job-title";

class JobTitleRepository implements IJobTitleRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/jobTitle/${id}`);
    return response.data;
  }

  async create(input: JobTitle): Promise<Message<JobTitle>> {
    const response = await httpClient.post(`/jobTitle`, { data: input });
    return response.data;
  }

  async update(input: JobTitle): Promise<Message<boolean>> {
    const response = await httpClient.put(`/jobTitle/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: BaseInputFilter): Promise<Message<JobTitle[]>> {
    const response = await httpClient.get(`/jobTitle`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<JobTitle>> {
    const response = await httpClient.get(`/jobTitle/${id}`);
    return response.data;
  }
}

export default new JobTitleRepository();
